import './MobileStyle1.scss';

const MobileStyle1 = ({ children }: { children: JSX.Element }) => {
  return children;
};

export default MobileStyle1;
